import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Currency as CurrencyField } from 'gw-components-platform-react';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import metadata from './VehicleCoverageTable.metadata.json5';
import './VehicleCoverageTable.messages';
import { IntlContext } from '@jutro/locale';
import {formatNumber} from '@jutro/components';

const getCell = (items, index, property) => {
    return !_.isObject(items[property.id]) ? items[property.id] : null;
};

const getCurrencyCell = (items, index, property) => {
    return (
        <CurrencyField
            id={`currency_${index}`}
            value={items[property.id]}
            readOnly
            hideLabel
            showOptional={false}
        />
    );
};

export function VehicleCoverageTable({ data }) {
    const intl = useContext(IntlContext);

    const getVehicleCoverageData = (covs) => {
        var excessLimitCov = covs.filter((c)=> c.name =="Excess Liability")[0];
        if(excessLimitCov && excessLimitCov.limit){
            let excessLimit = excessLimitCov.limit            
            covs.forEach((lc)=> {
                if(lc.name.trim() == ("Bodily Injury - Liability").trim()){
                    const totalLimit =  parseInt(lc.limit.replace(/,/g,'')) + parseInt(excessLimit.replace(/,/g,'')) + "";                        
                    lc.limit = formatNumber(intl, { format: 'decimal', showFractions: true}, totalLimit);
                }                
            })
            return covs.filter((coverage) => {
                return coverage.name != 'Excess Liability'
            });
        }
       return covs;
    }

    const overrides = {
        vehicleCoverageTable: {
            data: getVehicleCoverageData(data)
        },
        vehicleDriverTable: {
            visible: false
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            getCellCoverage: getCell,
            getCellCurrencyCoverage: getCurrencyCell
        }
    };

   return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={data}
            overrideProps={overrides}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
        />
    );
}

VehicleCoverageTable.propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({}))
};

VehicleCoverageTable.defaultProps = {
    data: []
};

export function VehicleDriverTable({ data }) {
    const overrides = {
        vehicleDriverTable: {
            data: data
        },
        vehicleCoverageTable: {
            visible: false
        },

    };

    const resolvers = {
        resolveCallbackMap: {
            getCellDriver: getCell
        }
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={data}
            overrideProps={overrides}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
        />
    );
}

VehicleDriverTable.propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({}))
};

VehicleDriverTable.defaultProps = {
    data: []
};
export default { VehicleCoverageTable, VehicleDriverTable };
